import api from "./api";

// -------------------- HARVEST TYPES --------------------
export const fetchHarvestTypes = async () => {
  const res = await api.get("/core/harvest-types/");
  return res.data;
};

export const createHarvestType = async (harvestType) => {
  const res = await api.post("/core/harvest-types/", harvestType);
  return res.data;
};

export const updateHarvestType = async (id, harvestType) => {
  const res = await api.put(`/core/harvest-types/${id}/`, harvestType);
  return res.data;
};

export const deleteHarvestType = async (id) => {
  const res = await api.delete(`/core/harvest-types/${id}/`);
  return res.data;
};
